import type { ReactNode } from 'react'
import { NavLink, type NavLinkProps } from 'react-router'
import { cn } from '@/shared/lib/utils'

interface SubNavLinkProps extends NavLinkProps {
  className?: string
  children: ReactNode | ReactNode[] | string
  show?: boolean
  disabled?: boolean
}

export const SubNavLink = ({
  className,
  children,
  show = true,
  disabled = false,
  ...props
}: SubNavLinkProps) => {
  if (!show) return null

  return (
    <NavLink
      className={cn([
        'flex gap-2 text-sm justify-start items-center w-full py-3 px-7 transition-all duration-200 leading-tight text-foreground cursor-pointer hover:bg-muted dark:hover:bg-background lg:border-r-4 border-transparent font-medium whitespace-nowrap lg:break-words',
        '[&.active]:bg-blue-400/10 [&.active_span]:text-primary [&.active]:font-semibold [&.active]:border-b-2 lg:[&.active]:border-b-0 [&.active]:border-primary',
        'whitespace-nowrap lg:whitespace-normal lg:pr-6',
        { 'opacity-50 pointer-events-none': disabled },
        className
      ])}
      aria-disabled={disabled}
      {...props}
    >
      {children}
    </NavLink>
  )
}
